import React from 'react';
import styled from 'styled-components';
import {breakPoint} from '../styles/var';
import OuterLink from './OuterLink';
import Img from './Img';

// images
import mombaby_logo from '../assets/img/pc07-3.png';
import logo_1 from '../assets/img/pc07-4.png';
import logo_2 from '../assets/img/pc07-5.png';
import logo_3 from '../assets/img/pc07-6.png';
import logo_4 from '../assets/img/pc07-7.png';
import logo_5 from '../assets/img/pc07-8.png';
import logo_6 from '../assets/img/pc07-9.png';
import img_9 from '../assets/img/9.png';

const FooterStyles = styled.footer`
  position: relative;
  background-color: var(--white);
  
  .mombaby {
    max-width: 13rem;
  }
  .fixed-img {
    position: absolute;
  }

  .img-9 {
    bottom: 0;
    right: 10%;
    width: 274px;
  }
  @media (max-width: ${breakPoint.smMax}) {
    .img-9 {
      width: 74px;
    }
  }
  
`

const SponsorGroupStyles = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
  > .title {
    text-align: center;
    margin-bottom: 1rem;
  }
  > .sponsor {
    border-top: 1px solid var(--black);
    padding: 2rem;
    display: flex;
    gap: 1.5rem;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
  }
  @media (max-width: ${breakPoint.smMax}) {
    margin-bottom: 1rem;
    .sponsor {
      max-width: calc(100% - 4rem);
      padding: 1.5rem 0;
    }
  }
`;

const CopyrightStyles = styled.div`
  --bg: var(--tertiary);
  padding: 1.5rem 2rem;
  background-color: var(--bg);
  @media (max-width: ${breakPoint.max}) {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  @media (max-width: ${breakPoint.smMax}) {
    span {
      display: block;
    }
  }
`;

const Footer = () => {
    return (
        <FooterStyles>
            <Img src={img_9} wrapProps={{className: 'fixed-img img-9'}} />
            <SponsorGroupStyles>
                <h3 className={"title"}>共同主辦</h3>
                <div className="sponsor">
                    <OuterLink href="https://www.mombaby.com.tw/">
                        <Img src={mombaby_logo} wrapProps={{className: 'mombaby'}}/>
                    </OuterLink>
                    <OuterLink href="https://www.pixnet.net/">
                        <Img src={logo_1} wrapProps={{className: ''}}/>
                    </OuterLink>
                    <OuterLink href="https://www.influenxio.com/zh-TW/">
                        <Img src={logo_2} wrapProps={{className: ''}}/>
                    </OuterLink>
                    <OuterLink href="https://www.youtube.com/c/IDEASTUBE">
                        <Img src={logo_3} wrapProps={{className: ''}}/>
                    </OuterLink>
                </div>
            </SponsorGroupStyles>
            <SponsorGroupStyles>
                <h3 className={"title"}>合作品牌</h3>
                <div className="sponsor">
                    <OuterLink href="https://www.mombb.tw/">
                        <Img src={logo_4} wrapProps={{className: ''}}/>
                    </OuterLink>
                    <OuterLink href="https://www.artmis.com.tw/">
                        <Img src={logo_5} wrapProps={{className: ''}}/>
                    </OuterLink>
                    <OuterLink href="https://bit.ly/3zYZb1w">
                        <Img src={logo_6} wrapProps={{className: ''}}/>
                    </OuterLink>
                </div>
            </SponsorGroupStyles>

            <CopyrightStyles className="center">
                Copyright {new Date().getFullYear()}.媽媽寶寶 All rights reserved. <span>版權所有，禁止擅自轉貼</span>
            </CopyrightStyles>
        </FooterStyles>
    )
}

export default Footer;
